import useEmitter from '@/composables/useEmitter'

const emitter = useEmitter()

export const recipientSearchInputFocusEvent = 'focusRecipientSearch'

export function focusRecipientSearch() {
    emitter?.emit(recipientSearchInputFocusEvent)
}
